(function () {
  const yotpoInstanceIds = ['1358829', '1358826'];

  function getLoginUrl() {
    const hostname = window.location.hostname;
    const path = window.location.pathname;

    // BE-NL
    if (
      hostname === 'www.mustela.be' &&
      (path === '/nl' || path.startsWith('/nl/'))
    ) {
      return '/nl/account/login';
    }

    // NL-NL
    // www.mustela.nl -> /account/login

    // BE-FR
    // www.mustela.be -> /account/login

    return '/account/login';
  }

  window.addEventListener(
    'click',
    function (event) {
      const path = event.composedPath
        ? event.composedPath()
        : [];

      let isYotpoWidget = false;
      let clickedText = '';

      for (const el of path) {
        if (!el) continue;

        if (el.getAttribute) {
          const instanceId =
            el.getAttribute('data-yotpo-instance-id');

          if (
            instanceId &&
            yotpoInstanceIds.includes(instanceId)
          ) {
            isYotpoWidget = true;
          }
        }

        if (el.innerText) {
          clickedText += ' ' + el.innerText;
        }
      }

      if (!isYotpoWidget) return;

      const text = clickedText.toLowerCase();

      /*
       * Only intercept the logged-out Product Points CTA.
       *
       * NL:
       * - Inloggen
       *
       * EN:
       * - Sign in
       * - Log in
       *
       * FR:
       * - Connectez
       * - Connexion
       */
      const isLoginButton =
        text.includes('inloggen') ||
        text.includes('sign in') ||
        text.includes('log in') ||
        text.includes('connectez') ||
        text.includes('connexion');

      if (!isLoginButton) return;

      /*
       * Prevent Sales Motivator / Free Gifts from
       * catching the Product Points login click and
       * redirecting the customer to /checkout.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const loginUrl = getLoginUrl();

      window.location.replace(
        window.location.origin + loginUrl
      );
    },
    true
  );
})();